export default __webpack_public_path__ + "static/media/standard_95x125.5324950b.svg";